import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { getCategoryConfig } from "../../utils/bulkOperationsConfig";
import { findCategory } from "./categoryRegistry";

/**
 * Resolves /bulk-order-operations/:category to its screen. An unknown category, or
 * one this country has not enabled, falls back to the list rather than rendering
 * an empty page — the route guard has already established the user may be here.
 */
const CategoryRouter = () => {
	const { category: categoryKey } = useParams<{ category: string }>();
	const category = findCategory(categoryKey);

	if (!category || !getCategoryConfig(category.key)?.enabled) {
		return <Navigate to={"/bulk-order-operations"} replace />;
	}

	return <>{category.component}</>;
};

export default CategoryRouter;
